import Cookies from 'js-cookie'

const TokenKey = 'token'
// 获取token值
export function getToken() {
  if (window.location.host == "localhost:9527") {
    return Cookies.get(TokenKey)
  } else {
    return Cookies.get(TokenKey, { domain: domain })
  }


}
var PATTERN_IP = /^\d+(\.\d+)?$/;
var domain = process.env.VUE_APP_BASE_API_domain;
console.log(domain);
export function setToken(token) {
  console.log(window.location.host)
  if (window.location.host == "localhost:9527") {
    return Cookies.set(TokenKey, token);
  }
  if (PATTERN_IP.test(domain.split('.')[0])) {// ip
    console.log('ip')
    return Cookies.set(TokenKey, token);
  } else {// 域名
    console.log('域名')
    return Cookies.set(TokenKey, token, { domain: domain });
  }
}
// 删除token值
export function removeToken() {
  if (window.location.host == "localhost:9527") {
    return Cookies.remove(TokenKey);
  }
  if (PATTERN_IP.test(domain.split('.')[0])) {// ip
    return Cookies.remove(TokenKey);
  } else {// 域名
    Cookies.remove(TokenKey, { domain: domain });
  }
}
const Account_type = 'account_type'
// 获取account_type值
export function getaccount_type() {
  return Cookies.get(Account_type)
}

export function setaccount_type(account_type) {
  if (window.location.host == "localhost:9527") {
    return Cookies.set(Account_type, account_type)
  } else {
    return Cookies.set(Account_type, account_type, { domain: domain })
  }

}
// 删除account_type值
export function removeaccount_type() {
  return Cookies.remove(Account_type)
}
// 获取name值
const Name = 'name'
export function getname() {
  return Cookies.get(Name)
}
export function setname(name) {
  if (window.location.host == "localhost:9527") {
    return Cookies.set(Name, name)
  } else {
    return Cookies.set(Name, name, { domain: domain })
  }

}
// 删除account_type值
export function removename() {
  return Cookies.remove(Name)
}
